module.exports = __webpack_public_path__ + "img/wallet.e2d4866.webp";